import React from "react";
import { Growl } from "primereact/growl";
import { TabView, TabPanel } from "primereact/tabview";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Message } from "primereact/message";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import servicioHttp from "../servicio/ServicioHttp";
import servicioObjetos from '../servicio/ServicioObjetos';
import servicioArchivos from '../servicio/ServicioArchivos';
import servicioGeneradorAnios from '../servicio/ServicioGeneradorAnios';


const SELECCIONE_REGISTRO = { label: "* Registro Patronal:", value: null };
/**
 * Vista Detalle del apartado Emisiones
 *
 * @ maritza
 */

const TODOS = { label: "Todos", value: 0 };
const MESES = [
    { label: "Enero", value: "Enero" },
    { label: "Febrero", value: "Febrero" },
    { label: "Marzo", value: "Marzo" },
    { label: "Abril", value: "Abril" },
    { label: "Mayo", value: "Mayo" },
    { label: "Junio", value: "Junio" },
    { label: "Julio", value: "Julio" },
    { label: "Agosto", value: "Agosto" },
    { label: "Septiembre", value: "Septiembre" },
    { label: "Octubre", value: "Octubre" },
    { label: "Noviembre", value: "Noviembre" },
    { label: "Diciembre", value: "Diciembre" }];

const ANIOS = servicioGeneradorAnios.generarAnios();

const JOIN_PRINCIPAL_EMA = {
        "ttResumenEmisionEma": "alias_ttResumenEmisionEma",    
        "alias_ttResumenEmisionEma.ttEmision": "alias_ttEmision", 
        "tcTrabajador":"alias_tcTrabajador"
    };

    const JOIN_PRINCIPAL_EBA = {
        "ttResumenEmisionEba": "alias_ttResumenEmisionEba",    
        "alias_ttResumenEmisionEba.ttEmision": "alias_ttEmision", 
        "tcTrabajador":"alias_tcTrabajador"
    };

    const PAGINACION_INICIAL={
        registrosPorPagina: 10,
        join: null,
        restriccionesDinamicas: [
        ]
    }

export class Detalle extends React.Component {


    constructor() {
        super();
        this.state = {
            registrosPatronales: [],
            trabajadores: [],
            tipoEmision: [
                { label: "Tipo de Emisión", value: null },
                { label: "EMA", value: 1 },
                { label: "EBA", value: 2 }],
            errores: {},
            consulta: {},
            activeIndex: 0,
            paginacion: PAGINACION_INICIAL
        };
    }

    componentDidMount() {
        this.obtenerRegistrosPatronales();
    }

    /**
     * Método para llenar el dropdown con los registros patronales.
     */
    obtenerRegistrosPatronales = () => {
        servicioHttp.consumirPostHttp('empresa/obtener_registro_patronal.json').then(response => {
            let registrosPatronales = [SELECCIONE_REGISTRO];
            var newArray = registrosPatronales.concat(response.data.lista);
            let { consulta } = this.state;
            consulta.registroPatronal = SELECCIONE_REGISTRO.value;

            consulta.mes = TODOS.value;
            consulta.anio = TODOS.value;
            let arregloMeses = [TODOS];
            arregloMeses = arregloMeses.concat(MESES);

            let arregloAnios = [TODOS];
            arregloAnios = arregloAnios.concat(ANIOS);

            this.setState({ registrosPatronales: newArray, consulta: consulta, meses: arregloMeses, anios: arregloAnios });
        }).catch(error => {

        });
    };

    /**
     * Método que valida, que se seleccionen datos de los dropdown
     * (estos no deben estar vacíos).
     * 
     */
    validarFormulario = (consulta) => {
        const errores = {};
        if (consulta.registroPatronal === 0 && consulta.mes === 0 && consulta.anio === 0) {
            errores.anio = "Seleccione año";
            errores.mes = "Seleccione mes";
            errores.registroPatronal = "Selecciones un registro patronal";
        }
        if (servicioObjetos.esObjetoVacio(consulta.trabajador))
            errores.trabajador = "Seleccione un registro patronal después un afiliado";
        return errores;
    };

    asignarValores = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
        if (event.target.id === "consulta.registroPatronal" && !servicioObjetos.esObjetoVacio(event.target.value)) {
            this.cargarTrabajadores(event.target.value);
        }
    }

    /**
 * Método para llenar el dropdown con los datos del afiliado (NSS- Afiliado).
 * Primero se debe seleccionar un registro patronal, para que el dropdown se llene con
 * la información de los afiliados que esten relacionados con el registro patronal seleccionado.
 * 
 * @param {*} registroPatronal 
 */
    cargarTrabajadores = (id) => {
        this.setState({
            activeIndex: 0,
            errores: {},
            trabajadores: [],
            listaEmisionMensualAnticipada: [],
            listaEmisionBimestralAnticipada: []
        });
        servicioHttp.consumirPostHttp('trabajador/consulta_por_empresa.json', { id: id }).then(response => {
            this.setState({ trabajadores: response.data.lista });
        }).catch(error => {

        });
    }

    realizarBusqueda = () => {
        let { consulta,paginacion } = this.state;
        let errores = this.validarFormulario(consulta);
        this.setState({
            errores: errores,
            listaEmisionMensualAnticipada: [],
            listaEmisionBimestralAnticipada: [],
            activeIndex: 0
        });
        if (servicioObjetos.esObjetoVacio(errores)) {
            paginacion.join = JOIN_PRINCIPAL_EMA;
            paginacion.restriccionesDinamicas = [];
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_tcTrabajador.id",
                valorPropiedad: consulta.trabajador
            });
           
            if (consulta.anio !== 0 && consulta.mes !== 0) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "alias_ttEmision.periodo",
                    valorPropiedad: consulta.mes + " " + consulta.anio
                });
            }
            if (consulta.anio !== 0 && consulta.mes === 0) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "like",
                    nombrePropiedad: "alias_ttEmision.periodo",
                    valorPropiedad: consulta.anio,
                    modoLike: "ANYWHERE"
                });
            }


            servicioHttp.consumirPostHttp('movimientosema/consultar.json', paginacion).then(responseMovimientosEma => {
                paginacion.join = JOIN_PRINCIPAL_EBA;
                servicioHttp.consumirPostHttp('movimientoseba/consultar.json', paginacion).then(responseMovimientosEba => {
                    let listaEmisionMensualAnticipada = responseMovimientosEma.data.objeto.datos
                    let listaEmisionBimestralAnticipada = responseMovimientosEba.data.objeto.datos;
                    let activeIndex = 0;
                    if (!servicioObjetos.esObjetoVacio(listaEmisionMensualAnticipada) && !servicioObjetos.esObjetoVacio(listaEmisionBimestralAnticipada)) {
                        activeIndex = 1;
                    } else if (!servicioObjetos.esObjetoVacio(listaEmisionMensualAnticipada) && servicioObjetos.esObjetoVacio(listaEmisionBimestralAnticipada)) {
                        activeIndex = 1;
                    }
                    else if (servicioObjetos.esObjetoVacio(listaEmisionMensualAnticipada) && !servicioObjetos.esObjetoVacio(listaEmisionBimestralAnticipada)) {
                        activeIndex = 2;
                    }
                    this.setState({
                        listaEmisionMensualAnticipada: listaEmisionMensualAnticipada,
                        listaEmisionBimestralAnticipada: listaEmisionBimestralAnticipada,
                        activeIndex: activeIndex
                    });
                }).catch(error => {

                });
            }).catch(error => {

            });
            // if(consulta.tipo.value===1){
            //     this.consultaMovimientosEma();
            // }
            // if(consulta.tipo.value===2){
            //     this.consultaMovimientosEba();
            // }
        }
    }

    // consultaMovimientosEma = () => {
    //     let {consulta} =this.state;
    //     let paginacionWrapper = {
    //         registrosPorPagina: 10,
    //         join: {
    //             "tcTrabajador":"alias_tcTrabajador",                
    //         },
    //         restriccionesDinamicas: [
    //             {
    //                 tipoRestriccion: "eq",
    //                 nombrePropiedad: "alias_tcTrabajador.id",
    //                 valorPropiedad:consulta.trabajador.value 
    //             }
    //         ]
    //     };
    //     servicioHttp.consumirPostHttp('movimientosema/consultar.json',paginacionWrapper).then(response=>{
    //         this.setState({listaEmisionMensualAnticipada:response.data.objeto.datos,
    //             activeIndex:1});
    //     }).catch(error => {

    //     });
    // }

    // consultaMovimientosEba = () => {
    //     let {consulta} =this.state;
    //     let paginacionWrapper = {
    //         registrosPorPagina: 10,
    //         join: {
    //             "tcTrabajador":"alias_tcTrabajador",                
    //         },
    //         restriccionesDinamicas: [
    //             {
    //                 tipoRestriccion: "eq",
    //                 nombrePropiedad: "alias_tcTrabajador.id",
    //                 valorPropiedad:consulta.trabajador.value 
    //             }
    //         ]
    //     };
    //     servicioHttp.consumirPostHttp('movimientoseba/consultar.json',paginacionWrapper).then(response=>{
    //         this.setState({listaEmisionBimestralAnticipada:response.data.objeto.datos,
    //             activeIndex:2});
    //     }).catch(error => {

    //     });
    // }

    descargaExcelEma = () => {
        let { consulta } = this.state;
        let paginacionWrapper = {
            registrosPorPagina: 10,
            join: {
                "tcTrabajador": "alias_tcTrabajador",
            },
            restriccionesDinamicas: [
                {
                    tipoRestriccion: "eq",
                    nombrePropiedad: "alias_tcTrabajador.id",
                    valorPropiedad: consulta.trabajador
                }
            ]
        };
        servicioArchivos.descargaArchivo('movimientosema/descargar_excel.json', paginacionWrapper, this);
    }

    descargaExcelEba = () => {
        let { consulta } = this.state;
        let paginacionWrapper = {
            registrosPorPagina: 10,
            join: {
                "tcTrabajador": "alias_tcTrabajador",
            },
            restriccionesDinamicas: [
                {
                    tipoRestriccion: "eq",
                    nombrePropiedad: "alias_tcTrabajador.id",
                    valorPropiedad: consulta.trabajador
                }
            ]
        };
        servicioArchivos.descargaArchivo('movimientoseba/descargar_excel.json', paginacionWrapper, this);
    }

    reiniciarFrmBusqueda = () => {
        let consulta = {
            registroPatronal: SELECCIONE_REGISTRO.value
        };
        this.setState({
            consulta: consulta,
            activeIndex: 0,
            errores: {},
            trabajadores: [],
            listaEmisionMensualAnticipada: [],
            listaEmisionBimestralAnticipada: []
        });
    }

    regresar = () => {
        this.setState({ activeIndex: 0 });
    }

    imprimirTrabajador = (id) => {
        let { trabajadores } = this.state;
        let elementoBuscar = trabajadores.find((trabajador) => trabajador.value === id);
        return servicioObjetos.esObjetoVacio(elementoBuscar) ? "" : elementoBuscar.label;
    }

    imprimirEmpresa = (id) => {
        let { registrosPatronales } = this.state;
        let elementoBuscar = registrosPatronales.find((rp) => rp.value === id);
        return servicioObjetos.esObjetoVacio(elementoBuscar) ? "" : elementoBuscar.label;
    }

    render() {

        let { anios, meses, consulta, errores, trabajadores, registrosPatronales, activeIndex,
            listaEmisionMensualAnticipada, listaEmisionBimestralAnticipada } = this.state;

        let pieTablaExportarEma = <div className="p-fluid p-grid">
            <div className="p-col-12 p-md-2">
                {!servicioObjetos.esObjetoVacio(listaEmisionMensualAnticipada) ? <Button className="p-button-secondary" type="button" onClick={this.descargaExcelEma} name="Excel" label="Excel" icon="pi-md-import-export" tooltip="Excel"></Button> : null}
            </div>
        </div>;

        let pieTablaExportarEba = <div className="p-fluid p-grid">
            <div className="p-col-12 p-md-2">
                {!servicioObjetos.esObjetoVacio(listaEmisionBimestralAnticipada) ? <Button className="p-button-secondary" type="button" onClick={this.descargaExcelEba} name="Excel" label="Excel" icon="pi-md-import-export" tooltip="Excel"></Button> : null}
            </div>
        </div>;
        return (

            <div className="p-fluid">
                <Growl ref={(el) => (this.growl = el)} />
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <h1>Detalle</h1>
                        </div>
                    </div>
                </div>
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <TabView activeIndex={activeIndex} onTabChange={(e) => this.setState({ activeIndex: e.index })}>
                                <TabPanel header="Buscar">
                                    <h1>Consulta de Detalle de Emisión</h1>
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-2"><b>Registro Patronal:</b></div>
                                        <div className="p-col-12 p-md-4">
                                            <Dropdown filter={true} filterPlaceholder="Filtra por RP o Nombre corto" 
                                            filterBy="value,label" showClear={true}
                                            appendTo={document.body} optionLabel="label" optionValue="value"
                                            options={registrosPatronales} id="consulta.registroPatronal" 
                                            name="consulta.registroPatronal" value={consulta.registroPatronal} 
                                            onChange={(e) => this.asignarValores(e, false)} autoWidth={false} />
                                            {errores.registroPatronal ? (<div><br /> <Message severity="error" text={errores.registroPatronal} />{" "}</div>) : null}
                                        </div>
                                        {/* <div className="p-col-12 p-md-3"><b>Tipo Emisión:</b></div>
                                        <div className="p-col-12 p-md-3">
                                            <Dropdown appendTo={document.body} optionLabel="label" id="consulta.tipo" name="consulta.tipo" options={tipoEmision} value={consulta.tipo} onChange={(e) => this.asignarValores(e, false)} autoWidth={false} />
                                            {errores.tipo ? (<div><br /> <Message severity="error" text={errores.tipo} />{" "}</div>) : null}
                                        </div> */}
                                        <div className="p-col-12 p-md-1"><b>Afiliado:</b></div>
                                        <div className="p-col-12 p-md-5">
                                            <Dropdown filter={true} filterBy="label,value" 
                                            showClear={true} appendTo={document.body} optionLabel="label" 
                                            id="consulta.trabajador" name="consulta.trabajador" 
                                            options={trabajadores} value={consulta.trabajador} 
                                            onChange={(e) => this.asignarValores(e, false)} autoWidth={false} />
                                            {errores.trabajador ? (<div><br /> <Message severity="error" text={errores.trabajador} />{" "}</div>) : null}
                                        </div>
                                        <div className="p-col-12 p-md-2">
                                            <label ><b>Periodo:</b></label>
                                        </div>
                                        <div className="p-col-12 p-md-5">
                                            <Dropdown appendTo={document.body} placeholder="Año:" 
                                            id="consulta.anio" name="consulta.anio" optionLabel="label" 
                                            options={anios} value={consulta.anio} 
                                            onChange={(e) => this.asignarValores(e, false)} autoWidth={false} />
                                            {errores.anio ? <div><br /> <Message severity="error" text={errores.anio} /> </div> : null}
                                        </div>
                                        <div className="p-col-12 p-md-5">
                                            <Dropdown appendTo={document.body} placeholder="Mes:" 
                                            id="consulta.mes" name="consulta.mes" optionLabel="label" 
                                            options={meses} value={consulta.mes} 
                                            onChange={(e) => this.asignarValores(e, false)} autoWidth={false} />
                                            {errores.mes ? <div><br /> <Message severity="error" text={errores.mes} /> </div> : null}
                                        </div>
                                    </div>
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-2"><Button label="Limpiar" icon="pi-md-refresh" onClick={this.reiniciarFrmBusqueda} /></div>
                                        <div className="p-col-12 p-md-2"><Button label="Buscar" icon="pi-md-search" onClick={this.realizarBusqueda} /></div>
                                    </div>
                                </TabPanel>
                                <TabPanel header="EMA" disabled={servicioObjetos.esObjetoVacio(listaEmisionMensualAnticipada)}>
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-2"><Button label="Regresar" icon="pi-md-arrow-back" onClick={this.regresar} /></div>
                                    </div>
                                    <h1>Consulta Detalle Emisión Mensual Anticipada</h1>
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-1"><h3><b>Afiliado:</b></h3></div>
                                        <div className="p-col-12 p-md-11">{servicioObjetos.esObjetoVacio(consulta.trabajador) ? null : this.imprimirTrabajador(consulta.trabajador) }</div>
                                        <div className="p-col-12 p-md-1"><b>Reg. Patronal:</b></div>
                                        <div className="p-col-12 p-md-11">{servicioObjetos.esObjetoVacio(consulta.registroPatronal) ? null : this.imprimirEmpresa(consulta.registroPatronal)}</div>
                                    </div>
                                    <DataTable footer={pieTablaExportarEma} header="Emisión Mensual Anticipada" value={listaEmisionMensualAnticipada} responsive={true} resizableColumns={true}>
                                        <Column header="Origen del Movimiento" field="origenDelMovimiento" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Tipo del Movimiento" field="tipoDelMovimiento" autoLayout={true} resizableColumns={true} style={{ width: '80px' }} />
                                        <Column header="Fecha del Movimiento" field="fechaDelMovimiento" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Días" field="dias" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Salario Diario" field="salarioDiario" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Cuota Fija" field="cuotaFija" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Excedente Patronal" field="cuotaFija" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Excedente Obrero" field="excedentePatronal" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Prestaciones en Dinero Patronal" field="prestacionesEnDineroPatronal" autoLayout={true} resizableColumns={true} style={{ width: '250px' }} />
                                        <Column header="Prestaciones en Dinero Obrero" field="prestacionesEnDineroObrero" autoLayout={true} resizableColumns={true} style={{ width: '250px' }} />
                                        <Column header="Gastos Médicos y Pensionados Patronal" field="gastosMedicosYPensionadosPatronal" autoLayout={true} resizableColumns={true} style={{ width: '250px' }} />
                                        <Column header="Gastos Médicos y Pensionados Obrero" field="gastosMedicosYPensionadosObrero" autoLayout={true} resizableColumns={true} style={{ width: '250px' }} />
                                        <Column header="Riesgos de Trabajo" field="riesgosDeTrabajo" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Invalidez y Vida Patronal" field="invalidezYVidaPatronal" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Invalidez y Vida Obrero" field="invalidezYVidaObrero" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Guarderías y Prestaciones Sociales" field="guarderiasYPrestacionesSociales" autoLayout={true} resizableColumns={true} style={{ width: '250px' }} />
                                        <Column header="Suma" field="total" autoLayout={true} resizableColumns={true} style={{ width: '100px' }} />
                                    </DataTable>
                                </TabPanel>
                                <TabPanel header="EBA" disabled={servicioObjetos.esObjetoVacio(listaEmisionBimestralAnticipada)}>
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-2"><Button label="Regresar" icon="pi-md-arrow-back" onClick={this.regresar} /></div>
                                    </div>
                                    <h1>Consulta Detalle Emisión Bimestral Anticipada</h1>
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-1"><h3><b>Afiliado:</b></h3></div>
                                        <div className="p-col-12 p-md-11">{servicioObjetos.esObjetoVacio(consulta.trabajador) ? null : this.imprimirTrabajador(consulta.trabajador)}</div>
                                        <div className="p-col-12 p-md-1"><b>Reg. Patronal:</b></div>
                                        <div className="p-col-12 p-md-11">{servicioObjetos.esObjetoVacio(consulta.registroPatronal) ? null : this.imprimirEmpresa(consulta.registroPatronal)}</div>
                                    </div>
                                    <DataTable footer={pieTablaExportarEba} header="Emisión Bimestral Anticipada" value={listaEmisionBimestralAnticipada} responsive={true} resizableColumns={true}>
                                        <Column header="Origen del Movimiento" field="origenDelMovimiento" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Tipo del Movimiento" field="tipoDelMovimiento" autoLayout={true} resizableColumns={true} style={{ width: '80px' }} />
                                        <Column header="Fecha del Movimiento" field="fechaDelMovimiento" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Días" field="dias" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Salario Diario" field="salarioDiario" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Retiro" field="retiro" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Cesantía en Edad Avanzada y Vejez Patronal" field="cesantiaEnEdadAvanzadaYVejezPatronal" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Cesantía en Edad Avanzada y Vejez Obrero" field="cesantiaEnEdadAvanzadaYVejezObrero" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Subtotal RCV" field="subtotalRcv" autoLayout={true} resizableColumns={true} style={{ width: '250px' }} />
                                        <Column header="Aportación Patronal" field="aportacionPatronal" autoLayout={true} resizableColumns={true} style={{ width: '250px' }} />
                                        <Column header="Tipo de Descuento" field="tipoDeDescuento" autoLayout={true} resizableColumns={true} style={{ width: '250px' }} />
                                        <Column header="Valor de Descuento" field="valorDeDescuento" autoLayout={true} resizableColumns={true} style={{ width: '250px' }} />
                                        <Column header="Amortización" field="amortizacion" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Subtotal Infonavit" field="subtotalInfonavit" autoLayout={true} resizableColumns={true} style={{ width: '200px' }} />
                                        <Column header="Suma" field="total" autoLayout={true} resizableColumns={true} style={{ width: '100px' }} />
                                    </DataTable>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
